<template>
    <b-container fluid class="px-md-5">
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">En Proceso</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay transacciones que coincidan con la búsqueda"
                    empty-text="No hay transacciones para mostrar"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(int_id)="row">
                        {{ row.item.payer === 'REMITEE' && row.item.int_id !== null ? '**' + (row.item.int_id).slice(-8) : row.item.int_id }}
                    </template>

                    <template #cell(actions)="row">
                        <b-button class="text-white" variant="info" size="sm" @click="getNotify(row.item)" title="Notificaciones" v-b-modal.notify>
                            <i class="material-icons">info</i>
                        </b-button>
                        <b-button variant="primary" size="sm" @click="getViewer(row.item.id)" title="Comprobante" :disabled="row.item.payment !== '2'" v-b-modal.voucher>
                            <i class="material-icons">photo</i>
                        </b-button>
                        <b-button variant="warning" size="sm" @click="getCancel(row.item.id)" title="Anular" :disabled="row.item.status > 106 || (row.item.status === 107 && row.item.payer !== 'JETPERU')">
                            <i class="material-icons">cancel</i>
                        </b-button>
                        <b-button variant="default" size="sm" :to="'/admin/request/'+row.item.id+'/details'" title="Detalles">
                            <i class="material-icons">visibility</i>
                        </b-button>
                    </template>

                    <template #cell(status_text)="row">
                        <template v-if="row.item.status === 109">
                            <span class="bg-success text-light rounded py-1 px-2">{{ row.item.status_text }}</span>
                        </template>
                        <template v-else-if="row.item.status === 110 || row.item.status === 111 || row.item.status === 112 || row.item.status === 113">
                            <span class="bg-danger text-light rounded py-1 px-2">{{ row.item.status_text }}</span>
                        </template>
                        <template v-else>
                            <span>{{ row.item.status_text }}</span>
                        </template>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>

                <!-- Modal Voucher Viewer -->
                <b-modal
                    id="voucher"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="text-center px-4 my-4"
                    :title="'ID: '+id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <img :src="'/'+voucher" :title="id" alt="Voucher" width="100%"/>
                </b-modal>

                <!-- Modal Notifications Viewer -->
                <b-modal
                    id="notify"
                    centered
                    no-fade
                    header-class="text-center"
                    header-bg-variant="primary"
                    header-text-variant="light"
                    header-close-variant="light"
                    footer-class="border-0"
                    hide-footer
                    body-class="px-4 my-4"
                    :title="'Notificaciones ID: ' + notify.id"
                    tabindex="-1"
                    role="dialog"
                    size="lg"
                    aria-hidden="true">
                    <template v-if="notify.data">
                        <!-- Error explícito del backend -->
                        <div v-if="notifyParsed && notifyParsed.error" class="alert alert-danger mb-3">
                            <strong>Error:</strong> {{ notifyParsed.error }}
                        </div>
                        <!-- Detalle del error de TerraPay (errorCode/errorDescription) -->
                        <div v-if="terrapayErrorDetail" class="alert alert-danger mb-3">
                            <strong>Detalle TerraPay [{{ terrapayErrorDetail.errorCode }}]:</strong> {{ terrapayErrorDetail.errorDescription }}
                            <div v-if="terrapayErrorDetail.errorCategory" class="mt-1"><small>Categoría: {{ terrapayErrorDetail.errorCategory }}</small></div>
                        </div>
                        <!-- Fallo detectado por el cron de TerraPay -->
                        <div v-if="notifyParsed && notifyParsed.terrapayFailedStatus" class="alert alert-danger mb-3">
                            <strong>TerraPay - Transacción Fallida</strong>
                            <div v-if="notifyParsed.terrapayFailedStatus.status" class="mt-1">Estado: <strong>{{ notifyParsed.terrapayFailedStatus.status }}</strong></div>
                            <div v-if="notifyParsed.terrapayFailedStatus.transactionStatus" class="mt-1">{{ notifyParsed.terrapayFailedStatus.transactionStatus }}</div>
                        </div>
                        <!-- Solo tiene accountStatus sin transactionReference (se quedó a medio camino) -->
                        <div v-else-if="notifyParsed && notifyParsed.status === 'available' && !notifyParsed.transactionReference && !notifyParsed.error" class="alert alert-warning mb-3">
                            <strong>Incompleto:</strong> La cuenta fue validada pero la transacción no se completó con el corresponsal.
                        </div>
                        <!-- Transacción creada exitosamente -->
                        <div v-else-if="notifyParsed && notifyParsed.transactionReference && !notifyParsed.error && !notifyParsed.terrapayFailedStatus" class="alert alert-success mb-3">
                            <strong>Referencia:</strong> {{ notifyParsed.transactionReference }}
                            <span v-if="notifyParsed.transactionStatus" class="ml-2">| {{ notifyParsed.transactionStatus }}</span>
                        </div>
                        <!-- Estado inicial PENDING -->
                        <div v-if="notifyParsed && notifyParsed.initialStatus && notifyParsed.initialStatus.status === 'PENDING'" class="alert alert-warning mb-3">
                            <strong>Estado Inicial:</strong> PENDING
                        </div>
                        <json-viewer :expand-depth="2" :value="notifyParsed"></json-viewer>
                    </template>
                    <template v-else>
                        <div class="text-center py-3">
                            <p class="text-muted mb-3">No hay datos de log del corresponsal para esta transacción.</p>
                        </div>
                        <div v-if="notify.info" class="border rounded p-3">
                            <h6 class="text-primary mb-3">Información de la Transacción</h6>
                            <table class="table table-sm table-borderless mb-0">
                                <tbody>
                                    <tr>
                                        <td class="font-weight-bold" style="width:40%">ID:</td>
                                        <td>{{ notify.info.id }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Corresponsal:</td>
                                        <td>{{ notify.info.payer }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Estado:</td>
                                        <td>
                                            <span :class="{
                                                'bg-success text-light rounded py-1 px-2': notify.info.status === 109,
                                                'bg-danger text-light rounded py-1 px-2': [110,111,112,113].includes(notify.info.status)
                                            }">{{ notify.info.status_text }}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Monto Envío:</td>
                                        <td>{{ notify.info.amount_send_text }} {{ notify.info.currency_send }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Monto Recibido:</td>
                                        <td>{{ notify.info.amount_receiver_text }} {{ notify.info.currency_receiver }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Fecha Creación:</td>
                                        <td>{{ notify.info.date }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Última Actualización:</td>
                                        <td>{{ notify.info.update }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </template>
                </b-modal>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Returns",
    data: () => ({
        id: 0,
        voucher: '',
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'ID', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'int_id', label: 'Código', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'payer', label: 'Corresponsal', sortable: false },
            { key: 'customer', label: 'Cliente/Agente', sortable: false },
            { key: 'country_receiver_text', label: 'País', sortable: false },
            { key: 'amount_send_text', label: 'Valor', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'currency_send', label: 'Moneda', sortable: false },
            { key: 'payment_text', label: 'Metodo', sortable: false },
            { key: 'status_text', label: 'Estado', sortable: false },
            { key: 'amount_send_usd_text', label: 'USD', sortable: false, thClass: 'text-sm-right', tdClass: 'text-sm-right' },
            { key: 'date', label: 'Fecha', sortable: false },
            { key: 'actions', label: 'Acción', sortable: false, thClass: 'text-sm-center', tdClass: 'text-sm-center' }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }],
        loading: false,
        notify: {
            id: 0,
            data: null,
            info: null
        }
    }),
    computed: {
        notifyParsed() {
            if (!this.notify.data) return null;
            try {
                return JSON.parse(this.notify.data);
            } catch (e) {
                return { error: 'Error al parsear datos', raw: this.notify.data };
            }
        },
        terrapayErrorDetail() {
            const d = this.notifyParsed;
            if (!d) return null;
            const paths = [
                d.accountStatus && d.accountStatus.error,
                d.accountStatus && d.accountStatus.response && d.accountStatus.response.error,
                d.respTerrapay && d.respTerrapay.error,
                d.respTerrapay && d.respTerrapay.response && d.respTerrapay.response.error,
                d.terrapayFailedStatus && d.terrapayFailedStatus.error,
            ];
            for (const err of paths) {
                if (err && (err.errorDescription || err.errorCode)) {
                    return err;
                }
            }
            return null;
        }
    },
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'generalpage');
        this.getIni();
    },
    methods: {
        getIni() {
            axios.get('/api/admin/reports/in-progress', this.form).then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.items;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
                this.totalRows = this.items.length;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getViewer(id) {
            this.id = id;
            const items = this.items;

            for (let i = 0; i < items.length; i++) {
                if (items[i].id === id) {
                    this.voucher = items[i].voucher;
                }
            }
        },
        getNotify(item) {
            this.notify.id = item.id;
            this.notify.data = item.data;
            this.notify.info = item;
        },
        getCancel(id) {
            this.$swal({
                title: '¿Estas seguro de anular este pago?',
                text: 'ID: ' + id,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, anular',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'En otro momento',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.id = id;

                    let formData = new FormData();
                    formData.append('id', id);

                    axios.post('/api/admin/payment/reject', formData).then(res => {
                        if (res.data.status === 'success') {
                            const items = this.items;

                            for (let i = 0; i < items.length; i++) {
                                if (items[i].id === id) {
                                    items.splice( i, 1 );
                                    this.totalRows = this.items.length;
                                }
                            }
                        }
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>

</style>
